import React, { useCallback, useRef, useState } from "react"
import { SwiperSlide } from "swiper/react"
import { Slider } from "./Slider"
import { Image } from "components/image/Image"
import { SingleGalleryImage } from "../gallery-types"

import "./gallery-slider.module.scss"
import { useSlider } from "../hooks/useSlider"
import { SwiperOptions, Swiper as SwiperClass } from "swiper"
interface GallerySliderProps {
  images: SingleGalleryImage[]
  firstSlideIndex: number
}

export const GallerySlider = ({
  images,
  firstSlideIndex,
}: GallerySliderProps) => {
  const slideIndex = useRef<number>(firstSlideIndex)
  const [swiper, setSwiper] = useState<SwiperClass>()
  const [control, setControl] = useState<SwiperClass>()

  return (
    <div className="fr-gallery-slider u-flex-center-align fr-container">
      <Slider
        className="fr-gallery-slider__images"
        onSwiper={setSwiper}
        initialSlide={slideIndex.current}
        controller={{ control: control }}
        pagination={false}
        autoHeight={true}
      >
        {images.map(({ elements }, index) => {
          if (!elements) return
          const { single_image } = elements

          const isWide =
            single_image?.value[0].width / single_image?.value[0].height > 2
              ? "wide"
              : ""
          const isTall =
            single_image?.value[0].width < single_image?.value[0].height
              ? "tall"
              : ""
          return (
            <SwiperSlide key={index} virtualIndex={index}>
              <div className="fr-gallery-slider__image-wrapper">
                <Image
                  image={single_image.value[0]}
                  alt={single_image.value[0]?.description ?? ""}
                  className={`fr-gallery-slider__image ${isTall} ${isWide}`}
                  imgStyle={{ objectFit: "contain" }}
                />
              </div>
            </SwiperSlide>
          )
        })}
      </Slider>

      <Slider
        className="fr-gallery-slider__controller"
        initialSlide={slideIndex.current}
        navigation
        onSwiper={setControl}
        controller={{ control: swiper }}
      >
        {images.map(({ elements }, index) => {
          if (!elements) return
          const { caption, single_image } = elements

          return (
            <SwiperSlide key={index} virtualIndex={index}>
              {caption?.value && (
                <p className="fr-gallery-slider__caption">{caption.value}</p>
              )}
            </SwiperSlide>
          )
        })}
      </Slider>
    </div>
  )
}
